import { trackPromise } from 'react-promise-tracker';

import api from '../../../../utils/API';
import type {
  VisaoGeralElasticidadeFiltroOutrosBody,
  VisaoGeralElasticidadeFiltroProdutoBody,
  VisaoGeralElasticidadeFiltroSalvoBody,
  VisaoGeralElasticidadeTableBody,
  VisaoGeralElasticidadeTableParams,
  PageElasticitySelectionResponse,
  IndustryDataFreshnessResponse,
} from './types';
import { MULTI_FILTERS_TRACKER_AREA, PRODUCT_REFERENCE_TRACKER_AREA, SEGMENTS_TRACKER_AREA, TABLE_TRACKER_AREA } from './constants';

const BASE_URL = process.env.REACT_APP_IND_CROSS_ELASTICITY_SETUP_URL;

export const getProdutctReference = (data: VisaoGeralElasticidadeFiltroProdutoBody, size: number) => {
  return trackPromise(
    api({
      url: `${BASE_URL}/products`,
      method: 'POST',
      data: JSON.stringify(data),
      params: {
        size: size || 50,
      },
      expectToken: true,
    }).then(resp => resp.data),
    PRODUCT_REFERENCE_TRACKER_AREA,
  );
};

export const getRegions = (data: VisaoGeralElasticidadeFiltroOutrosBody) => {
  return trackPromise(
    api({
      url: `${BASE_URL}/regions`,
      method: 'POST',
      data: data,
      expectToken: true,
    }).then(resp => resp.data),
    'elasticidade-regions',
  );
};

export const getSections = (data: VisaoGeralElasticidadeFiltroOutrosBody) => {
  return trackPromise(
    api({
      url: `${BASE_URL}/sections`,
      method: 'POST',
      data: data,
      expectToken: true,
    }).then(resp => resp.data),
    MULTI_FILTERS_TRACKER_AREA,
  );
};

export const getContents = (data: VisaoGeralElasticidadeFiltroOutrosBody) => {
  return trackPromise(
    api({
      url: `${BASE_URL}/contents`,
      method: 'POST',
      data: data,
      expectToken: true,
    }).then(resp => resp.data),
    MULTI_FILTERS_TRACKER_AREA,
  );
};

export const getCategories = (data: VisaoGeralElasticidadeFiltroOutrosBody) => {
  return trackPromise(
    api({
      url: `${BASE_URL}/categories`,
      method: 'POST',
      data: data,
      expectToken: true,
    }).then(resp => resp.data),
    MULTI_FILTERS_TRACKER_AREA,
  );
};

export const getBrands = (data: VisaoGeralElasticidadeFiltroOutrosBody) => {
  return trackPromise(
    api({
      url: `${BASE_URL}/brands`,
      method: 'POST',
      data: data,
      expectToken: true,
    }).then(resp => resp.data),
    MULTI_FILTERS_TRACKER_AREA,
  );
};

export const getManufacturers = (data: VisaoGeralElasticidadeFiltroOutrosBody) => {
  return trackPromise(
    api({
      url: `${BASE_URL}/manufacturers`,
      method: 'POST',
      data: data,
      expectToken: true,
    }).then(resp => resp.data),
    MULTI_FILTERS_TRACKER_AREA,
  );
};

export const getSegments = (data: VisaoGeralElasticidadeFiltroOutrosBody) => {
  return trackPromise(
    api({
      url: `${BASE_URL}/segments`,
      method: 'POST',
      data: data,
      expectToken: true,
    }).then(resp => resp.data),
    SEGMENTS_TRACKER_AREA,
  );
};

export const getVisaoGeralElasticidadeTable = (data: VisaoGeralElasticidadeTableBody, params: VisaoGeralElasticidadeTableParams) => {
  return trackPromise(
    api({
      url: `${BASE_URL}/elasticity-selections/table`,
      method: 'POST',
      params: {
        page: params.page,
        size: params.size,
        sortBy: params.sortBy,
        direction: params.direction,
        competitorMode: params.competitorMode,
        shareDisplayMode: params.shareDisplayMode,
      },
      data: data,
      expectToken: true,
    }).then(resp => resp.data),
    TABLE_TRACKER_AREA,
  );
};

export const saveFilters = (data: VisaoGeralElasticidadeFiltroSalvoBody) => {
  return trackPromise(
    api({
      url: `${BASE_URL}/elasticity/filters/saved`,
      method: 'POST',
      data: data,
      expectToken: true,
    }).then(resp => resp.data),
    TABLE_TRACKER_AREA,
  );
};

export const deleteSavedFilters = (id: number) => {
  return trackPromise(
    api({
      url: `${BASE_URL}/elasticity/filters/saved`,
      method: 'DELETE',
      params: {
        idFiltroSalvo: id,
      },
      expectToken: true,
    }).then(resp => resp.data),
    TABLE_TRACKER_AREA,
  );
};

export const getSavedFilters = (query: string) => {
  return trackPromise(
    api({
      url: `${BASE_URL}/elasticity/filters/saved/search`,
      method: 'GET',
      params: {
        query: query,
      },
      expectToken: true,
    }).then(resp => resp.data),
    'elasticidade-saved-filters',
  );
};

export const getIndustryDataFreshness = () =>
  trackPromise(
    api({
      url: `${BASE_URL}/industry/data-freshness`,
      method: 'GET',
      expectToken: true,
    }).then(resp => resp.data as unknown as IndustryDataFreshnessResponse),
    'elasticidade-data-freshness',
  );

export const getElasticitySelectionsPaged = (page = 0, size = 50) =>
  trackPromise(
    api({
      url: `${BASE_URL}/elasticity-selections/paged`,
      method: 'GET',
      params: { page, size },
      expectToken: true,
    }).then(resp => resp.data as PageElasticitySelectionResponse),
    'elasticidade-selections-paged',
  );
